import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/profile";
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, pwd);
      toast.success("Welcome back!");
      nav(next);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="container-x py-20 max-w-md">
      <div className="eyebrow mb-4">// Access</div>
      <h1 className="section-heading mb-8">Sign In</h1>
      <form onSubmit={submit} className="space-y-4 bg-[#121217] border border-white/10 p-8">
        <div>
          <label className="block text-[10px] font-mono-plex uppercase tracking-widest text-white/50 mb-2">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-black border border-white/10 px-4 py-3 focus:outline-none focus:border-[#FF5E00]"
            data-testid="login-email-input" />
        </div>
        <div>
          <label className="block text-[10px] font-mono-plex uppercase tracking-widest text-white/50 mb-2">Password</label>
          <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)}
            className="w-full bg-black border border-white/10 px-4 py-3 focus:outline-none focus:border-[#FF5E00]"
            data-testid="login-password-input" />
        </div>
        <button disabled={loading} className="btn-primary w-full" data-testid="login-submit-btn">
          {loading ? "Signing in..." : "Sign In"}
        </button>
        <div className="text-xs text-white/50 text-center font-mono-plex">
          Don&apos;t have an account? <Link to="/register" className="text-[#B3FF00] hover:underline" data-testid="login-goto-register">Sign up</Link>
        </div>
        <button type="button"
          onClick={() => {
            // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
            const redirectUrl = window.location.origin + "/auth/callback";
            window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
          }}
          className="w-full py-3 border border-white/10 text-white/80 font-display uppercase tracking-widest text-xs hover:border-[#B3FF00]/60 hover:text-[#B3FF00] flex items-center justify-center gap-2"
          data-testid="login-google-btn">
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Continue with Google
        </button>
      </form>
    </div>
  );
}
